import { faTimesCircle } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaTruckLoading } from "react-icons/fa";
import { GiSandsOfTime } from "react-icons/gi";
import { IoShieldCheckmarkOutline } from "react-icons/io5";
import { useAppDispatch } from "hooks/hooks";
import { useEffect, useState } from "react";
import { DiffDays, FormatDateShort, FormatTime } from "utils/dateUtils";
import { IRequisition } from "../domain/IRequisition";
import { setDeleteRequisitionModalOpen } from "../requisition.slice";
import { selectState as selectStateAuth } from "authentication/main.slice";
import { hasFullAccessTo } from "utils/authUtil";
import { useSelector } from "react-redux";
import { REQUISITION_WAREHOUSE_MODULE_NAME } from "../domain/RequisitionsModule";

interface IProps {
  requisition: IRequisition;
  index: number;
  doAccept: (requisitionId: number) => void;
  doReply: (requisitionId: number, text: string) => void;
  isLast: boolean;
  lastElementRef: any;
};

const Requisition = ({
  requisition,
  index,
  doAccept,
  doReply,
  isLast,
  lastElementRef }: IProps) => {
  const dispatch = useAppDispatch();
  const [dateTimeCreated, setDateTimeCreated] = useState<string>("");
  const [timeUpdated, setTimeUpdated] = useState<string>("");
  const [replyText, setReplyText] = useState<string>("");
  const { user } = useSelector(selectStateAuth);

  useEffect(() => {
    const dateCreated = FormatDateShort(requisition.dateTimeCreated);
    const timeCreated = FormatTime(requisition.dateTimeCreated);
    setDateTimeCreated(dateCreated + ", " + timeCreated);
    setTimeUpdated(FormatTime(requisition.dateTimeUpdated));
  }, [requisition.dateTimeCreated, requisition.dateTimeUpdated])

  const changeReplyText = (e: any) => {
    setReplyText(e.target.value);
  }

  const isEditable = (requisition: IRequisition) => {
    let currentDateTime = new Date();
    let requisitionCreationDateTime = new Date(requisition.dateTimeCreated);
    let diffInMillis: number = currentDateTime.getTime() - requisitionCreationDateTime.getTime();
    const timeForEditExpired = diffInMillis >= 1000 * 60 * 15;
    return !timeForEditExpired && !requisition.isAccepted;
  }

  const isUrgent = (requisition: IRequisition) => {
    const mustDeliverToday = DiffDays(requisition.dueDate, requisition.dateTimeCreated) === 0;
    return mustDeliverToday && !requisition.isAccepted;
  }

  const submitReply = async (e: any) => {
    e.preventDefault();
    doReply(requisition.requisitionId, replyText);
  }

  return (
    <div
      ref={isLast ? lastElementRef : undefined}
      className={`requirement-item`}
    >
      <span className="status-icon">
        {isEditable(requisition)
          ? (<GiSandsOfTime />)
          : (<IoShieldCheckmarkOutline />)}
      </span>
      <div className={`requirement-item-header${isUrgent(requisition) ? ' urgent' : ''}`}>
        <span className="user">{requisition.creator.name}</span>,
        <span className="title">{requisition.project.name}</span>(
        <span className="date-time">menjano: {dateTimeCreated}</span>
        {requisition.dateTimeUpdated &&
          <span className="date-time">&nbsp;{`- ${timeUpdated}`}</span>}
        <span className="date-time">;&nbsp;</span>
        <span className={`date-time`}>rok: {FormatDateShort(requisition.dueDate)}</span>
        )
      </div>
      <div className={`body`}>
        {requisition.text.split("\n").map((line, index) => (
          <p key={index}>
            {line}
            <br />
          </p>
        ))}
        {!requisition.isAccepted &&
          <span
            className="info-icon"
            onClick={(e) => {
              e.stopPropagation();
              doAccept(requisition.requisitionId);
            }}
          >
            <FaTruckLoading />
          </span>
        }
      </div>
      <div className="requirement-item-footer">{
        requisition.executor
          ? <span className="executor">( {`Izvršilac: ${requisition.executor.name}`} )</span>
          : <span>( {requisition.updateCounter} - promena )</span>}
      </div>
      <form onSubmit={submitReply}>
        <input
          type="text"
          defaultValue={requisition.replyText || ""}
          className="requirement-input"
          onChange={changeReplyText}
        />
      </form>
      {hasFullAccessTo(user, REQUISITION_WAREHOUSE_MODULE_NAME)
        ? (
          <button
            className="close-button"
            onClick={(e) => {
              e.stopPropagation();
              dispatch(setDeleteRequisitionModalOpen({ visible: true, index }));
            }
            }
          >
            <FontAwesomeIcon icon={faTimesCircle} />
          </button>
        )
        : (<></>)}
    </div>
  );
}
export default Requisition;
